import dayjs from 'dayjs';

type FormatExpectedDeliveryArgs = {
  days: number;
  deliveryMessage?: string;
};

/**
 * P0: non-empty delivery_message from API (mapped to deliveryMessage)
 * P1: days === 0 → Today
 * P2: days === 1 → Tomorrow
 * P3: formatted calendar date
 */
export const formatExpectedDeliveryLabel = ({
  days,
  deliveryMessage,
}: FormatExpectedDeliveryArgs): string => {
  const trimmedMessage = deliveryMessage?.trim();
  if (trimmedMessage) {
    return trimmedMessage;
  }

  if (days === 0) {
    return 'Today';
  }

  if (days === 1) {
    return 'Tomorrow';
  }

  return dayjs().add(days, 'day').format('ddd, DD MMM');
};
